import { removeLettersAfterCharacter } from '../../helpers/TextHelper';
import { callGetImage } from '../../services/ImageService';
import {
  callCreateTicketNoProduct,
  callGetCustomerTickets,
  callMakeSelfServiceByMotive,
  callValidateProductByMotive,
} from '../../services/TicketService';
import {
  APPEND_PRODUCT_IN_TICKET,
  MAKE_SELF_SERVICE_ERROR,
  MAKE_SELF_SERVICE_LOADING,
  MAKE_SELF_SERVICE_SUCCESS,
  SET_TICKETS,
  TICKETS_ERROR,
  TICKETS_LOADING,
  TICKETS_NOT_FOUND,
  VALIDATE_PRODUCT_BY_MOTIVE_SUCCESS,
  VALIDATE_PRODUCT_BY_MOTIVE_ERROR,
  VALIDATE_PRODUCT_BY_MOTIVE_LOADING,
  OPEN_MODAL_SUCCESS,
  CLOSE_MODAL_SUCCESS,
  OPEN_MODAL_CONFIRMATION_TICKET,
  CLOSE_MODAL_CONFIRMATION_TICKET,
  CONFIRMATION_TICKET,
  CREATE_TICKET_NO_PRODUCT_LOADING,
  CREATE_TICKET_NO_PRODUCT_SUCCESS,
  CREATE_TICKET_NO_PRODUCT_ERROR,
  SET_MESSAGES,
  SET_STATUS,
} from '../types/TicketTypes';

import { errorMessage } from './FlashActions';

export const setTickets = (tickets) => {
  return { type: SET_TICKETS, tickets };
};

export const getTicketsLoading = () => {
  return { type: TICKETS_LOADING };
};

export const getTicketsError = () => {
  return { type: TICKETS_ERROR };
};

export const getTicketsNotFound = () => {
  return { type: TICKETS_NOT_FOUND };
};

export const appendProductInTicket = (sku, product) => {
  return { type: APPEND_PRODUCT_IN_TICKET, product, sku };
};

export const validateProductByMotiveLoading = () => {
  return { type: VALIDATE_PRODUCT_BY_MOTIVE_LOADING };
};

export const validateProductByMotiveError = (validation) => {
  return { type: VALIDATE_PRODUCT_BY_MOTIVE_ERROR, validation };
};

export const validateProductByMotiveSuccess = (validation) => {
  return { type: VALIDATE_PRODUCT_BY_MOTIVE_SUCCESS, validation };
};

export const setMessageResponse = (msg) => {
  return { type: SET_MESSAGES, msg };
};

export const setStatusResponse = (status) => {
  return { type: SET_STATUS, status };
};

export const makeSelfServiceByMotiveLoading = () => {
  return { type: MAKE_SELF_SERVICE_LOADING };
};

export const makeSelfServiceByMotiveError = () => {
  return { type: MAKE_SELF_SERVICE_ERROR };
};

export const makeSelfServiceByMotiveSuccess = (selfService) => {
  return { type: MAKE_SELF_SERVICE_SUCCESS, selfService };
};

export const openModalSuccessCreate = (modalInformation) => {
  return { type: OPEN_MODAL_SUCCESS, modalInformation };
};

export const closeModalSuccessCreate = () => {
  return { type: CLOSE_MODAL_SUCCESS };
};

export const openModalConfirmationTicket = (modalInformation) => {
  return { type: OPEN_MODAL_CONFIRMATION_TICKET, modalInformation };
};

export const closeModalConfirmationTicket = () => {
  return { type: CLOSE_MODAL_CONFIRMATION_TICKET };
};

export const confirmationTicket = () => {
  return { type: CONFIRMATION_TICKET };
};

export const createTicketNoProductLoading = () => {
  return { type: CREATE_TICKET_NO_PRODUCT_LOADING };
};

export const createTicketNoProductError = () => {
  return { type: CREATE_TICKET_NO_PRODUCT_ERROR };
};

export const createTicketNoProductSuccess = (ticket) => {
  return { type: CREATE_TICKET_NO_PRODUCT_SUCCESS, ticket };
};

export const getTickets = () => {
  return async (dispatch, getState) => {
    const { logonId } = getState().profileReducer.profile;
    try {
      dispatch(getTicketsLoading());
      const res = await callGetCustomerTickets(logonId);
      if (res.status === 200) {
        dispatch(setTickets(res.data.tickets));
      } else if (res.status === 404) dispatch(getTicketsNotFound());
      else dispatch(getTicketsError());
    } catch (err) {
      dispatch(getTicketsError());
    }
  };
};

export const getTicketImage = (sku) => {
  const noPhoto = { thumbnailImage: 'no-photo' };
  return async (dispatch) => {
    if (!sku) dispatch(appendProductInTicket(sku, noPhoto));
    else {
      try {
        const res = await callGetImage(removeLettersAfterCharacter(sku, '-'));
        if (res.status === 200) {
          dispatch(appendProductInTicket(sku, res.data));
        } else dispatch(appendProductInTicket(sku, noPhoto));
      } catch (err) {
        dispatch(appendProductInTicket(sku, noPhoto));
      }
    }
  };
};

export const validateProductByMotive = (motiveId, data) => {
  return async (dispatch) => {
    try {
      dispatch(validateProductByMotiveLoading());
      const res = await callValidateProductByMotive(motiveId, data);
      if (res.status === 200) {
        dispatch(validateProductByMotiveSuccess(res.data));
        if (res.data.msg) dispatch(setMessageResponse(res.data.msg));
        if (res.data.status) dispatch(setStatusResponse(res.data.status));
      } else dispatch(validateProductByMotiveError(res.data));
    } catch (err) {
      dispatch(validateProductByMotiveError(err));
    }
  };
};

export const makeSelfServiceByMotive = (motiveId, data) => {
  return async (dispatch, getState) => {
    dispatch(makeSelfServiceByMotiveError());
    if (!data.phone) {
      dispatch(
        errorMessage(
          'Por favor actualiza tu número de teléfono en la sección "Mi Perfil" antes de realizar la solicitud.',
        ),
      );
    } else {
      const { logonId } = getState().profileReducer.profile;
      await makeSelfServiceByMotiveAction(motiveId, logonId, data, dispatch);
    }
  };
};

const makeSelfServiceByMotiveAction = async (
  motiveId,
  logonId,
  data,
  dispatch,
) => {
  try {
    dispatch(makeSelfServiceByMotiveLoading());
    const res = await callMakeSelfServiceByMotive(logonId, motiveId, data);
    if (res.status === 200) dispatch(makeSelfServiceByMotiveSuccess(res.data));
    else {
      dispatch(makeSelfServiceByMotiveError());
      dispatch(
        errorMessage(
          'Hubo un problema al realizar la autoatención, intenta nuevamente.',
        ),
      );
    }
  } catch (err) {
    dispatch(makeSelfServiceByMotiveError());
    dispatch(
      errorMessage(
        'Hubo un problema al realizar la autoatención, intenta nuevamente.',
      ),
    );
  }
};

export const createTicketNoProduct = (data) => {
  return async (dispatch, getState) => {
    dispatch(createTicketNoProductLoading());
    const { logonId } = getState().profileReducer.profile;
    if (!data.telefono) {
      dispatch(
        errorMessage(
          'Por favor actualiza tu número de teléfono en la sección "Mi Perfil" antes de realizar la solicitud.',
        ),
      );
      dispatch(createTicketNoProductError());
    } else {
      await createTicketNoProductAction(logonId, data, dispatch);
    }
  };
};

const createTicketNoProductAction = async (logonId, data, dispatch) => {
  try {
    const res = await callCreateTicketNoProduct(logonId, data);
    if (res.status === 200) dispatch(createTicketNoProductSuccess(res.data));
    else {
      dispatch(createTicketNoProductError());
      dispatch(
        errorMessage(
          'Hubo un problema al crear tu solicitud, intenta nuevamente.',
        ),
      );
    }
  } catch (err) {
    dispatch(createTicketNoProductError());
    dispatch(
      errorMessage(
        'Hubo un problema al crear tu solicitud, intenta nuevamente.',
      ),
    );
  }
};
